import * as Types from '../../../../../../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetMaximumCommutePreferenceQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMaximumCommutePreferenceQuery = { __typename?: 'Query', jobSeekerProfileStructuredData?: { __typename?: 'JobSeekerProfileStructuredDataPayload', preferences: Array<{ __typename?: 'JobSeekerProfileStructuredDataPreference', id?: string | null, maximumCommute?: { __typename?: 'JobSeekerProfileStructuredDataCommute', timeMinutes?: number | null } | null }> } | null };


export const GetMaximumCommutePreferenceDocument = gql`
    query GetMaximumCommutePreference {
  jobSeekerProfileStructuredData(
    input: {queryFilter: {dataCategories: [CONFIRMED_BY_USER]}}
  ) {
    preferences {
      id
      maximumCommute {
        timeMinutes
      }
    }
  }
}
    `;

/**
 * __useGetMaximumCommutePreferenceQuery__
 *
 * To run a query within a React component, call `useGetMaximumCommutePreferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaximumCommutePreferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaximumCommutePreferenceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMaximumCommutePreferenceQuery(baseOptions?: Apollo.QueryHookOptions<GetMaximumCommutePreferenceQuery, GetMaximumCommutePreferenceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaximumCommutePreferenceQuery, GetMaximumCommutePreferenceQueryVariables>(GetMaximumCommutePreferenceDocument, options);
      }
export function useGetMaximumCommutePreferenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMaximumCommutePreferenceQuery, GetMaximumCommutePreferenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaximumCommutePreferenceQuery, GetMaximumCommutePreferenceQueryVariables>(GetMaximumCommutePreferenceDocument, options);
        }
export function useGetMaximumCommutePreferenceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMaximumCommutePreferenceQuery, GetMaximumCommutePreferenceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMaximumCommutePreferenceQuery, GetMaximumCommutePreferenceQueryVariables>(GetMaximumCommutePreferenceDocument, options);
        }
export type GetMaximumCommutePreferenceQueryHookResult = ReturnType<typeof useGetMaximumCommutePreferenceQuery>;
export type GetMaximumCommutePreferenceLazyQueryHookResult = ReturnType<typeof useGetMaximumCommutePreferenceLazyQuery>;
export type GetMaximumCommutePreferenceSuspenseQueryHookResult = ReturnType<typeof useGetMaximumCommutePreferenceSuspenseQuery>;
export type GetMaximumCommutePreferenceQueryResult = Apollo.QueryResult<GetMaximumCommutePreferenceQuery, GetMaximumCommutePreferenceQueryVariables>;